module.exports = __webpack_public_path__ + "static/media/deskpro_icon.bfee151c.svg";